// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__q3rrl","content":"LoadingAlert_content__3zaaN"};